<template>
  <div class="details-component__content content">
    <v-client-table class="mobile-1070" :data="ticketsList" :columns="columns" :options="options">
      <span slot="name" slot-scope="props">
        <span class="mobile">{{ $t('common.name') }}:</span>
        {{ props.row.name[DEF_LANG] }} </span>
      <span slot="type" slot-scope="props"> {{ $t('ticket_types.' + props.row.price_rule_type) }} </span>
      <span slot="price" slot-scope="props">
        {{ props.row.pricing_rule.rules_string }}
        {{ props.row.pricing_rule.unit_price_string }}
        {{ props.row.pricing_rule.unit_type }}
      </span>
      <span slot="available" slot-scope="props"> {{ props.row.availability }} </span>
      <span v-if="canEditTypes" slot="edit" slot-scope="props">
        <a class="link" v-on:click="openListModal(props.row)">
          {{ $t('common.change') }}
        </a>
      </span>
      <div v-if="canEditTypes" slot="remove_product" slot-scope="props" class="delete-wrapper">
        <a @click="showConfirmationForRemovingType(props.row.id, props.row.name, props.row.kioskId)" :id="props.row.id">
          <span class="delete-wrapper__icon icon icon--cross"></span>
        </a>
      </div>
    </v-client-table>
    <ConfirmationModal v-if="showConfirmationModal && canEditTypes" @cancel="cancelTypeRemove" @confirmed="commitRemoveProduct($event)">
      <h1 slot="header">{{ $t('ticket_types.delete_confirmation.header') }}</h1>
      <p slot="body">{{ $t('ticket_types.delete_confirmation.text') }} {{ deletingItem.name }}</p>
    </ConfirmationModal>
    <ListModal v-if="showListModal" @cancel="closeListModal($event)" @confirmed="onSubmit($event)">
      <TicketTypeForm :itemData="itemData"/>
    </ListModal>
  </div>
</template>

<script>

import ListWidget from '../../../common/ListWidget';
import {configData} from "../mixins/configData";
import ConfirmationModal from "../../../common/ConfirmationModal";
import {apiService} from "../api/services";
import TicketTypeForm from "../ui/TypeForm";
import ListModal from "../../../common/ListModal";
import {submitData} from "../mixins/submitData";

export default {
  mixins: [configData, apiService, submitData],
  props: ['ticketsList', 'canEditTypes'],
  components: {
    ListWidget,
    ConfirmationModal,
    TicketTypeForm,
    ListModal
  },
  data() {
    return {
      columns: ['name', 'type', 'price', 'available', 'edit', 'remove_product'],
      options: {
        texts: {
          noResults: this.$t('tenants.no_matching_records'),
          count: this.$t('tables.count'),
        },
        filterable: false,
        rowClassCallback: () => 'VueTables__row',
        headings: {
          type: () => this.$t('ticket_types.type'),
          name: () => this.$t('common.name'),
          price: () => this.$t('ticket_types.price'),
          available: () => this.$t('ticket_types.available'),
          remove_product: () => (''),
          edit: () => (''),
        }
      },
      showListModal: false,
      showConfirmationModal: false,
      deletingItem: {
        id: null,
        name: null,
        kioskId: null
      },
      itemData: null
    }
  },
  methods: {
    closeListModal(event) {
      this.showListModal = false;
    },
    onTypeSaved() {
      this.$emit('type-saved')
    },
    openListModal(itemData) {
      this.itemData = {
        ...itemData,
        ...itemData.pricing_rule
      }
      this.showListModal = !this.showListModal;
    },
    commitRemoveProduct(event) {
      event.preventDefault()
      this.deleteItem(this.deletingItem.id, this.deletingItem.kioskId)
      this.$store.dispatch('tenants/ticketTypes/excludeItem', this.deletingItem.id)
      this.emptyDeletingItem()
      this.showConfirmationModal = false
    },
    cancelTypeRemove() {
      this.showConfirmationModal = false
      this.emptyDeletingItem()
    },
    showConfirmationForRemovingType(id, name, kioskId) {
      this.deletingItem.id = id
      this.deletingItem.name = name[localStorage.getItem('locale')]
      this.deletingItem.kioskId = kioskId
      this.showConfirmationModal = true
    },
    emptyDeletingItem() {
      this.deletingItem.id = null
      this.deletingItem.name = null
      this.deletingItem.kioskId = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tenants/ticket-types/ui/TypesList.vue